import apis from "../apis"
import Native from '../../utils/Native'

/**
 * 处理sdk初始化及一系列事件
 */
var preChannel = null;
export function initWebSocketPlugin(_clinetSDK) {
    return store => {

        store.subscribe((mutation) => {

            // 机器人初始化完成立即IM登录
            if (mutation.type === 'm_fund_info') {
                apis.anonymousUser(store.getters.authParams)
					.then(data => {
						if (data.RetCode == '1') {
							store.commit("m_auth_user", data.Data)
						} else {
							throw "fail";
						}
					}).catch(err => {
						console.log("loginFailure", err);
					})
                // _clinetSDK.anonymousUser(JSON.stringify(store.getters.authParams), function(data) {
                //     if (data.result == 1) {
                //         store.commit("m_auth_user", data.data)
                //     }
                // }, function(err) {
                //     logger("loginFailure", err);
                // });
            }

            // 用户登陆成功立即初始化事件
            if (mutation.type === 'm_auth_user') {
                initEvents(store, _clinetSDK);
            }


            // channelId 变更，立即切换
            if (mutation.type === "m_channel_id") {
                var channelId = store.getters.channelId;
                if (preChannel != channelId) {
                    if (preChannel) { // 退出之前的Channel
                        _clinetSDK.exitChannel(preChannel)
                    }

                    preChannel = channelId;
                    _clinetSDK.joinChannel(preChannel);
                } else {
                    logger("channelId未变，跳过")
                }
            }

            if (mutation.type === "m_init_ok") {
                if (store.getters.customerId.length !== 16) {
                  $historyStorage.push = () => {}
                }

                switch (store.getters.customerState) {
                    case 1:
                        Bus.$emit("applyLineup");
                        break;
                    case 2:
                        Bus.$emit("getStaff");
                        break;
                    default:
                        Bus.$emit("welcomeMsg");
                }
                Bus.$emit("getClientHistoryMessages");
            }
        })
    }
}

// 初始化 websocket 连接事件
function initEvents(store, _clinetSDK) {
    _clinetSDK.on("connected", function() {
        _clinetSDK.info("开始登录");
        var _params = store.getters.loginByIMToken;
        _clinetSDK.loginByIMToken(
            _params.imUserID,
            _params.accessToken,
            _params.device,
            _params.Version,
            _params.refreshToken
        );
        store.commit("m_channel_id", store.getters.channelId)
        store.commit('m_init_ok');
        setInterval(() => {
                Bus.$emit("robotRefreshTime")
            }, 3 * 60 * 1000)
            // Bus.$emit('applyLineup')
    });

    // 重连  刷新页面
    _clinetSDK.on("reConnected", function() {
        window.location.reload();
    });

    // 异常
    _clinetSDK.on("error", function(data) {
      logger("clinetSDK异常：" + JSON.stringify(data))
      // Bus.$emit("sendToIMFail", "clinetSDK异常：" + JSON.stringify(data))
      Bus.$emit("error", data)
    });

    //订阅频道的回执
    _clinetSDK.on("joinChannelSuccess", function(ch) {
        Bus.$emit("joinChannelSuccess", ch)
    });

    var counts = 0;  // pollmessages 使用
    _clinetSDK.on("pollmessages", function(data) {
      try {
        data = typeof data == "string" ? JSON.parse(data) : data;
      } catch(e) {
        logger(e)
      }

      while(data.count > counts) {
        var Content = data.data[counts].Content;
        try {
          Content = typeof Content == "string" ? JSON.parse(Content) : Content
        }catch(e) {
          logger(e)
        }
        _clinetSDK.setMaxID(Content.MsgIndexID);
        if (Content.SenderID != store.getters.imUserID) {
          Bus.$emit("messages", Content);
        }
        counts++;
      }
      counts = 0;
      // Bus.$emit("messages", data);
    });

    _clinetSDK.on("messages", function(data) {
        Bus.$emit("messages", data);
    })

    _clinetSDK.on('refreshToken', token => {
        // 直接提交， 刷新token
        Bus.$emit("refreshToken", token);
    })

    Bus.$on("sendMsgToIM", function(msg, type, cb, errCb) {
        // 0：入库消息， 200 不入库，提示消息
        if (type === 0) {
          $historyStorage.push({Type: 9, MessageContent: msg, SendDateTime: new Date().getTime()})
        }
        _clinetSDK.sendToChannel(store.getters.channelId, msg, type || 0, (res) => {
            counts++;
            cb && cb(res)
        }, function(err) {
            errCb && errCb(err);
        })
    })

    // sdk内文件上传
    Bus.$on("sdkUploadImg", (name, str, cb, errCb) => {
        _clinetSDK.httpFileUpLoad(name, str, (res) => {
            cb && cb(res);
        }, (err) => {
            errCb && errCb(err);
        })
    })
}



// WEBPACK FOOTER //
// ./src/store/plugins/sdkEvents.js